






















import Vue from 'vue'
import XCardBody from './XCardBody.vue'
import XCardActions from '@/components/atoms/Card/XCardActions.vue'
interface CardProps {
  noBody?: boolean
  outlined?: boolean
}

/**
 * @see {@link https://material.io/components/cards#anatomy Cards}
 */
export default Vue.extend<{}, {}, {}, CardProps>({
  inheritAttrs: false,
  name: 'XCard',
  components: { XCardBody, XCardActions },
  props: {
    noBody: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasActions() {
      return !!this.$slots.actions
    },
    hasBody() {
      return !!this.$slots.body
    },
  },
})
